import Link from 'components/Link/Link';

export default Link;
